import React from 'react'
import './Rank.css'

const Rank = () => {

    const data = [
        {
            label: "Rank in Top 50",
            label2: "Universities By NIRF",
            img: "/assets/images/home/rank/img1.png"
        },
        {
            label: "'A++' Grade ",
            label2: "'Accreditation by NAAC",
            img: "/assets/images/home/rank/img2.png"
        },
        {
            label: "40 Years + of excellence ",
            label2: "in education",
            img: "/assets/images/home/rank/img3.png"
        },
        {
            label: "1,50,000 + strong ",
            label2: "alumni network across the globe",
            img: "/assets/images/home/rank/img4.png"
        },

    ]

    return (
        <section className='Rank'>
            <div className='container'>
                <div className='cards_holder'>
                    <div className='row me-0 ms-0'>
                        {data?.map((item) => {
                            return (
                                <div className='col-lg-3 col-sm-6 mb-3'>
                                    <div className='red_card'>
                                        <div className='img_holder'>
                                            <img src={process.env.PUBLIC_URL + item?.img} className='img' />
                                        </div>
                                        <p className='label_text'>{item?.label}</p>
                                        <p className='label_text'>{item?.label2}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Rank
